import { createContext } from 'react';
import { IProcessedProfile } from './typings';

export const ProfileContext = createContext<IProcessedProfile>(
  {} as IProcessedProfile,
);
